export default "__VITE_ASSET__UMKQkP6PB_j6pq1U6Zl6oQ__"